import { useMemo } from 'react';
import { TapQuestionCrossTabResult } from '../../../../api';

interface CrossTabBarDataProps {
  crossTabLabelsHash: Record<string, string>;
  crossTabResults: TapQuestionCrossTabResult;
  isHidingEmptyCrossTab: boolean;
}
export const useCrossTabBarData = ({
  crossTabLabelsHash,
  crossTabResults,
  isHidingEmptyCrossTab,
}: CrossTabBarDataProps) => {
  return useMemo(() => {
    if (!crossTabLabelsHash || !crossTabResults?.attributes?.results) {
      return false;
    }

    return Object.entries(crossTabResults?.attributes?.results?.answers)
      .map(
        ([crossTabAnswerId, answerValues]: [
          string,
          Record<string, unknown>
        ]) => {
          if (!answerValues?.answers && isHidingEmptyCrossTab) return null;

          return {
            answer_id: crossTabLabelsHash[crossTabAnswerId],
            ...(answerValues?.answers &&
              Object.entries(answerValues?.answers)
                .map(([answerId, crossTabAnswerValues]) => {
                  return {
                    ...{
                      [answerId.toString()]: crossTabAnswerValues?.percentage,
                      [answerId.toString() + '_total']:
                        crossTabAnswerValues?.total,
                    },
                  };
                })
                .reduce((acc, item) => {
                  return { ...acc, ...item };
                }, {})),
          };
        }
      )
      .filter(Boolean);
  }, [crossTabLabelsHash, crossTabResults, isHidingEmptyCrossTab]);
};
